import { TranslationKey } from "../components/IntlMessages/IntlMessages";

export enum CredentialType {
  Single = "single",
  Multiple = "multiple",
}
export enum CredentialOptionType {
  SingleNotRequired = "single-not-required",
  SingleRequired = "single-required",
  MultipleNotRequired = "multiple-not-required",
  MultipleNotRequiredNoSharedAll = "multiple-not-required-no-shared-all",
  MultipleNotRequiredSharedAll = "multiple-not-required-shared-all",
  MultipleRequiredNoSharedAll = "multiple-required-no-shared-all",
  MultipleRequiredSharedAll = "multiple-required-shared-all",
  Default = "default",
}
export const credentialTypes: {
  value: CredentialType;
  labelId: TranslationKey;
}[] = [
  { value: CredentialType.Single, labelId: "step.new.credential.single" },
  {
    value: CredentialType.Multiple,
    labelId: "step.new.credential.multiple",
  },
];
export const credentialOptions: Record<
  CredentialType,
  {
    title: TranslationKey;
    subTitle: TranslationKey;
    value: CredentialOptionType;
  }[]
> = {
  [CredentialType.Single]: [
    {
      title: "step.new.modal.notCredential.title",
      subTitle: "step.new.modal.notCredential.subTitle",
      value: CredentialOptionType.SingleNotRequired,
    },
    {
      title: "step.new.modal.requiredCredential.title",
      subTitle: "step.new.modal.requiredCredential.subTitle",
      value: CredentialOptionType.SingleRequired,
    },
  ],
  [CredentialType.Multiple]: [
    {
      title: "step.new.modal.notCredential.title",
      subTitle: "step.new.modal.multiple.notCredential.subTitle",
      value: CredentialOptionType.MultipleNotRequiredNoSharedAll,
    },
    {
      title: "step.new.modal.notCredential.title",
      subTitle: "step.new.modal.multiple.notCredential.shareAll.subTitle",
      value: CredentialOptionType.MultipleNotRequiredSharedAll,
    },
    {
      title: "step.new.modal.atLeastrequiredCredential.title",
      subTitle: "step.new.modal.atLeastrequiredCredential.subTitle",
      value: CredentialOptionType.MultipleRequiredNoSharedAll,
    },
    {
      title: "step.new.modal.allSharedCredential.title",
      subTitle: "step.new.modal.allSharedCredential.subTitle",
      value: CredentialOptionType.MultipleRequiredSharedAll,
    },
  ],
};
